import { useState, useEffect } from 'react';
import { ReqEnum } from 'const/requestStatus';
import { reqStatus } from '../types/orderTypes';
import { log } from './useFetchCouriers';
import {
  CourierDailyRating,
  fetchCourierRating,
} from '../fetch/fetchCourierRating';

export function useFetchCourierRating(date: string): any[] {
  const [fetchStatus, setFetchStatus] = useState<reqStatus>(ReqEnum.INIT);
  const [rating, setCourierRating] = useState<CourierDailyRating>(null);

  useEffect(() => {
    log('Reset state');
    setFetchStatus(ReqEnum.PENDING);
    log('Fetching courier rating');

    const fetchCourierRatingMethod = async () => {
      const rating: CourierDailyRating = await fetchCourierRating(date);
      setCourierRating(rating);
      setFetchStatus(ReqEnum.SUCCESS);
    };
    fetchCourierRatingMethod()
      .then(() => log('Fetched rating for courier'))
      .catch(error => console.error(error));
  }, [date]);

  return [rating, fetchStatus];
}
